<template>
  <div v-if="timelockOutcome !== null" class="timelock-countdowns">
    <div class="field">
      <label class="label is-flex is-align-items-center">
        Executable
        <span class="has-text-primary" v-if="proposalIsExecutable">NOW</span>
        <span class="has-text-primary" v-else><div class="loader is-small"></div></span>
      </label>
      <div class="control">
        <progress
          :class="{'is-primary': proposalIsExecutable, 'is-grey': !proposalIsExecutable}"
          class="progress is-small is-marginless"
          :value="$store.currentBlockHeight - timelockOutcome.poll.votingEndBlock.toNumber()"
          :max="$store.daoParameters.timelockItem.endBlock.minus(timelockOutcome.poll.votingEndBlock).toNumber()"
        />

        <div class="progress-footer">

          <p class="help">
            Vote ended <b>{{ calculateBlockTime(timelockOutcome.poll.votingEndBlock) }}</b> ago (block
            <a rel="noopener" target="_blank" :href="`${$store.tzstatsURL}/${timelockOutcome.poll.votingEndBlock}`">
              {{ timelockOutcome.poll.votingEndBlock.toLocaleString() }}
            </a>
            )
          </p>
          <p class="help">
            Executable
            <span v-if="!proposalIsExecutable">in </span>
            <b>{{ calculateBlockTime($store.daoParameters.timelockItem.endBlock) }}</b>
            <span v-if="proposalIsExecutable"> ago</span>
            (block
            <a rel="noopener" target="_blank" :href="`${$store.tzstatsURL}/${$store.daoParameters.timelockItem.endBlock}`">
              {{ $store.daoParameters.timelockItem.endBlock.toLocaleString() }}
            </a>
            )
          </p>
        </div>
      </div>
    </div>

    <div class="field">
      <label class="label is-flex is-align-items-center">
        Cancellable
        <span class="has-text-primary" v-if="proposalIsCancellable">NOW</span>
        <span class="has-text-primary" v-else><div class="loader is-small"></div></span>
      </label>
      <div class="control">
        <progress
          :class="{'is-primary': proposalIsCancellable, 'is-grey': !proposalIsCancellable}"
          class="progress is-small is-marginless"
          :value="$store.currentBlockHeight - timelockOutcome.poll.votingEndBlock.toNumber()"
          :max="$store.daoParameters.timelockItem.cancelBlock.minus(timelockOutcome.poll.votingEndBlock).toNumber()"
        />

        <div class="progress-footer">

          <p class="help">
            Vote ended <b>{{ calculateBlockTime(timelockOutcome.poll.votingEndBlock) }}</b> ago (block
            <a rel="noopener" target="_blank" :href="`${$store.tzstatsURL}/${timelockOutcome.poll.votingEndBlock}`">
              {{ timelockOutcome.poll.votingEndBlock.toLocaleString() }}
            </a>
            )
          </p>
          <p class="help">
            Cancellable
            <span v-if="!proposalIsCancellable">in </span>
            <b>{{ calculateBlockTime($store.daoParameters.timelockItem.cancelBlock) }}</b>
            <span v-if="proposalIsCancellable"> ago</span> (block
            <a rel="noopener" target="_blank" :href="`${$store.tzstatsURL}/${$store.daoParameters.timelockItem.cancelBlock}`">
              {{ $store.daoParameters.timelockItem.cancelBlock.toLocaleString() }}
            </a>
            )
          </p>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import moment from "moment";

export default {
  name: 'TimelockCountdowns',
  props: ['timelockItem', 'timelockOutcome'],
  mounted(){

  },
  components: {

  },
  data(){
    return {
    }
  },
  methods: {
    calculateBlockTime(blockHeight){
      const durationSeconds = blockHeight.minus(this.$store.currentBlockHeight) * this.$store.blockTime
      // return moment.duration(durationSeconds).humanize(true)
      return moment.duration(Math.abs(durationSeconds)).format(
        'd[d] h[h] m[m] s[s]',
        {
          largest: 2
        }
      )
    },
  },
  computed: {
    proposalIsExecutable(){
      return this.$store.daoParameters.timelockItem.endBlock.minus(this.$store.currentBlockHeight).isLessThanOrEqualTo(0)
    },
    proposalIsCancellable(){
      return this.$store.daoParameters.timelockItem.cancelBlock.minus(this.$store.currentBlockHeight).isLessThanOrEqualTo(0)
    }
  }
}
</script>

<style type="text/scss" lang="scss">
@import '../assets/sass/globals';
.timelock-countdowns{
  .progress-footer{
    padding-top: 0.5rem;
    display: flex;
    justify-content: space-between;
  }
  .field > .label span{
    margin-left: 0.25rem;
  }
}
</style>
